module.exports = __webpack_public_path__ + "media/images/pinterest@2x-deaca7f6044949ee24c90e7dc82f2c2d.png";